// extracted by mini-css-extract-plugin
export default {"empty":"EmptyState_empty__qPW3v","mark":"EmptyState_mark__Uun5j"};